import OffersService from "../../services/crud/OfferService";
import { TableProps } from "./types";
import Booking from "../../models/Booking";
import GenericItemsTable, { DefaultColumnMapper } from "./GenericItemsTable";
import { OfferFormGenericForm } from "../forms/OfferForm";
import Offer from "../../models/Offer";
import AccountService from "../../services/crud/AccountService";
import Account from "../../models/Account";
import ColorInput from "../forms/components/ColorPicker";

async function load(): Promise<Offer[]> {

  const [offerList, accounts] = await Promise.all([
    OffersService.list(),
    AccountService.list(),
  ]);

  const list = offerList.map((o) => ({
    ...o,
    updatedAtAsDate: (o as any).updatedAtAsDate,
    accounts: accounts.filter((a) => o.accountIds?.includes(a.id)).map((a) => `${Account.typeEmoji(a.type)} ${a.name}`),
  } as any));
  return list;
}

export const GenericOffersTable = ({ ...rest }: TableProps<Offer>) => {
  return (
    <GenericItemsTable
      actions={{ select: true, edit: true, delete: true }}
      includeColumns={["name", "startDate", "endDate", "voucherName", "tspKey", "accounts", "updatedAt", "actions"]}
      excludeColumns={["updatedAt"]}
      model={Offer}
      form={OfferFormGenericForm}
      formCreate={OfferFormGenericForm}
      formEdit={OfferFormGenericForm}
      service={OffersService}
      dataLoader={load}
      columnMapper={(col) => {
        col = DefaultColumnMapper(col);
        if (col.key == 'accounts') {
          col.render = (text, record, index) => {
            const accounts = record?.accounts;
            return (<div style={{whiteSpace:"pre-wrap"}}>
              {`${accounts.join("\n")}`}
            </div>);
          }
        }
        return col;
      }}
      {...rest}></GenericItemsTable>
  );
};
